export enum BusinessThingDamageCause {
  FIRE = 'FIRE',
  WATER = 'WATER',
  THEFT = 'THEFT',
  VANDALISM = 'VANDALISM',
  BREAKAGE = 'BREAKAGE',
  NATURAL_DISASTER = 'NATURAL_DISASTER',
  OTHER = 'OTHER',
}

export const getBusinessThingDamageCauseLabel = (cause: BusinessThingDamageCause): string => {
  switch (cause) {
    case BusinessThingDamageCause.FIRE:
      return $localize`Incendie`;
    case BusinessThingDamageCause.WATER:
      return $localize`Eau`;
    case BusinessThingDamageCause.THEFT:
      return $localize`Vol`;
    case BusinessThingDamageCause.VANDALISM:
      return $localize`Vandalisme`;
    case BusinessThingDamageCause.BREAKAGE:
      return $localize`Bris`;
    case BusinessThingDamageCause.NATURAL_DISASTER:
      return $localize`Événement naturel`;
    case BusinessThingDamageCause.OTHER:
      return $localize`Autre`;
    default:
      return '';
  }
};
